import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Spinner from 'Components/Spinner';
import { paramsToObject } from 'common/utils/common.utils';
import { FullheightScreen } from 'Components/FullheightScreen/FullheightScreen';

const RawExternalLoginPage = ({
  AuthStore: { loginUrl, setInitialQueryParams },
}) => {
  const { i18n } = useTranslation();
  const regServiceLocale = i18n.language.toUpperCase();
  useEffect(() => {
    const query = new URLSearchParams(window?.location.search);
    setInitialQueryParams(paramsToObject(query));
  }, []);
  return (
    <FullheightScreen>
      {loginUrl === '.' && <Spinner />}
      {loginUrl !== '.' && (
        <iframe
          src={`${loginUrl}/${regServiceLocale}`}
          height="512"
          width="100%"
          title="sign up"
          frameBorder="0"
        />
      )}
    </FullheightScreen>
  );
};

export const ExternalLoginPage = inject('AuthStore')(
  observer(RawExternalLoginPage),
);
